import { byBoolean, byDate, byNumber, byString } from "sort-es";

import { FlagHeaderDTO } from "./flagAPI";
import { ColumnSorter, nullableSort, SortClauses } from "./utils/sorting";

/**
 * Sorts flags by column ID.
 *
 * Note: Column IDs (e.g., "lastCheck") are separate from DTO property names
 * (e.g., "lastCheckAt"). This function handles the mapping from column IDs
 * to the actual DTO properties.
 */
export const sortByFlagColumn: ColumnSorter<FlagHeaderDTO, string> = (
  columnId,
  desc,
): SortClauses<FlagHeaderDTO> => {
  switch (columnId) {
    case "name":
    case "key":
      return [[(i) => i[columnId], byString({ lowercase: true, desc })]];
    case "createdAt":
      return [[(i) => i.createdAt, byDate({ nullable: true, desc })]];
    case "rolledOutToEveryoneAt":
      return [
        [(i) => i.rolledOutToEveryoneAt, byDate({ nullable: true, desc })],
      ];
    case "lastCheck":
      return [[(i) => i.lastCheckAt, byDate({ nullable: true, desc })]];
    case "lastTrack":
      return [[(i) => i.lastTrackAt, byDate({ nullable: true, desc })]];
    case "autoFeedbackSurveysEnabled":
      return [[(i) => i.automatedSurveysEnabled, nullableSort(desc)]];
    case "stale":
      return [[(i) => i.stale, byBoolean({ desc })]];
    case "stage":
      return [[(i) => i.stage?.order, byNumber({ desc: !desc })]];
    case "owner":
      return [
        [
          (i) => i.owner?.name,
          byString({ nullable: true, lowercase: true, desc }),
        ],
      ];
    case "archivingChecks":
      return [
        [
          (i) => {
            const count = [
              i.stale,
              i.codeRefsCleanedUp,
              i.noRecentChecks,
            ].filter(Boolean).length;
            return count;
          },
          byNumber({ desc }),
        ],
      ];
    case "environmentStatus":
      return [[(i) => i.stage?.order, byNumber({ desc: !desc })]];
    default:
      return [];
  }
};
